<template>
<v-container class="ma-0 pa-0 main">
<div>
<v-form v-on:submit.prevent="performLookup">
    <div class="searchPart">
        <div v-if="searching" class="searchResult">
            <v-progress-circular
              :size="30"
              color="primary"
              indeterminate
            ></v-progress-circular>
        </div>
        <div v-else-if="!searchDone">
            <v-text-field
            ref="lookuptextfield"
            :label="$t('enter_identifier')"
            v-model="identifier"
            ></v-text-field>
        </div>
        <div v-else-if="result" class="searchResult">
            <table>
                <tr>
                    <td>
                        <StatusIcon status="success" />
                    </td>
                    <td>
                        <div v-for="item in result">
                        {{ item }} {{ $t('is_registered') }}
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        <div v-else-if="error" class="searchResult">
            <table>
                <tr>
                    <td>
                        <StatusIcon status="error" />
                    </td>
                    <td>
                        {{ error }}
                    </td>
                </tr>
            </table>
        </div>
        <div v-else class="searchResult">
            <table>
                <tr>
                    <td>
                        <StatusIcon status="not_applicable" />
                    </td>
                    <td>
                        {{ identifier }} {{ $t('not_found') }}
                    </td>
                </tr>
            </table>
        </div>
    </div>
    <div class="buttonPart">
        <div v-if="searching">
            <v-btn small disabled class="button">{{ $t('search') }}</v-btn>
        </div>
        <div v-else-if="searchDone">
            <v-btn small @click="reset" class="button">{{ $t('search_again') }}</v-btn>
        </div>
        <div v-else>
            <v-btn small type="submit" class="button">{{ $t('search') }}</v-btn>
        </div>
    </div>
    <div class="language">
        <v-btn small @click="toggleLanguage()" class="langButton">
            <img src="~@/assets/nl_small.png" width="16"/> / <img src="~@/assets/gb_small.png" width="16"/>
        </v-btn>
    </div>
    <div>
        <v-icon class="help" @click="toggleShowHelp()">help</v-icon>
    </div>
</v-form>

</div>
<v-dialog v-model="showhelp" full-width>
<v-card>
<div @click="toggleShowHelp()" class="helptext">
{{ $t('info') }}
</div>
</v-card>
</v-dialog>
</v-container>
</template>

<script>
import StatusIcon from "@/components/StatusIcon.vue";

export default {
  name: 'SimpleLookup',
  components: {
    StatusIcon,
  },
  data() {
    return {
      identifier: "",
      result: null,
      error: null,
      searching: false,
      searchDone: false,
      language: 'en',
      showhelp: false
    }
  },
  methods: {
    performLookup: function () {
        if (this.identifier === "") {
            return
        }
        this.searchDone = false
        this.searching = true
        this.result = null
        this.error = null
        var url = process.env.VUE_APP_BACKEND + "api/lookup/simple/" + this.identifier
        var headers = {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'POST, GET, PUT, OPTIONS, DELETE',
            'Access-Control-Allow-Headers': 'Access-Control-Allow-Methods, Access-Control-Allow-Origin, Origin, Accept, Content-Type',
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }
        this.axios.get(url, headers).then((response) => {
            this.searching = false
            this.searchDone = true
            if (response.data && response.data["identifiers"] && response.data["identifiers"].length > 0) {
                this.result = response.data["identifiers"]
            } else {
                this.result = null
            }
        }).catch((error) => {
            this.searching = false
            this.searchDone = true
            console.log(error)
            this.error = this.$t('backend_error')
        })
    },
    reset: function () {
        this.identifier = ""
        this.searchDone = false
        this.searching = false
        this.result = null
        this.error = null
        this.$nextTick(() => {
            this.$refs.lookuptextfield.focus()
        })
    },
    toggleLanguage: function() {
        if (this.$i18n.locale === 'en') {
            this.setLanguage('nl')
        } else {
            this.setLanguage('en')
        }
    },
    setLanguage: function(language) {
        if (language == 'en') {
            this.$i18n.locale = 'en'
        } else if (language == 'nl') {
            this.$i18n.locale = 'nl'
        } else {
            console.log("Language not supported: " + language);
        }
    },
    toggleShowHelp: function() {
        this.showhelp = !this.showhelp
    }
  },
  mounted() {
    let urlParams = new URLSearchParams(window.location.search);
    if(urlParams.has('lang')) {
        this.setLanguage(urlParams.get('lang'))
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  color: #42b983;
}
.v-text-field {
    //font-size: 1.5em;
}
.searchPart {
    width: 360px;
    padding-left: 10px;
}
.searchResult {
    position: absolute;
    top: 20px;
    margin: auto;
}
.buttonPart {
    position: absolute;
    top: 14px;
    left: 360px;
}
.button {
    min-width: 150px;
}
.v-btn {
    padding: 0px;
}
.language {
    position: absolute;
    top: 14px;
    left: 520px;
}
.help {
    position: absolute;
    top: 22px;
    left: 590px;
}
.main {
}

.langButton.v-btn {
  padding-left: 8px;
  padding-right: 8px;
  min-width: 0;
}
.helptext {
  font-size: 14px;
}
</style>
